export const prepareFolderData = (folderData, skip_user_ids = false) => {
        const _data = structuredClone(folderData)
        if(!skip_user_ids) {
            if(_data['allowed_groups']?.length > 0)
                _data['allowed_groups'] = _data['allowed_groups']?.map(g=>g.group_id)
            if(_data['allowed_users']?.length > 0)
                _data['allowed_users'] = _data['allowed_users']?.map(u=>u.user_id)
            if(_data['allowed_admins']?.length > 0)
                _data['allowed_admins'] = _data['allowed_admins']?.map(u=>u.user_id)
        }
        if(_data?.learning_path_completed_action?.group_ids?.length > 0)
                _data.learning_path_completed_action['group_ids'] = _data?.learning_path_completed_action?.group_ids?.map(g=>g.group_id ? g.group_id : g)
        return _data
    }